import React, { useState } from "react";
import "./AppsComponent.scss";
import Layout from "../../components/layout/LayoutComponent";
import AppsList from "../../components/appsList/AppsListComponent";
import AppListFilter from "../../components/appListFilter/AppListFilterComponent";
import CreateAppPopup from "../../components/createAppPopup/CreateAppPopupComponent";
import SurveyBuilderStore from "../../SurveyBuilderContext";
import ProgressWrapper from "../../components/createAppPopup/ProgressWrapper";

const FILTERS_STORAGE_KEY = "filter";
const DEFAULT_FILTERS = { apps: null, status: null };

function AppsComponent() {
    const [showCreateAppPopup, setShowCreateAppPopup] = useState(false);
    const [filters, setFilters] = useState(loadFilters);
    const [searchField, setSearchField] = useState("");

    return (
        <SurveyBuilderStore>
            <Layout>
                <AppListFilter
                    onAppCreate={() => setShowCreateAppPopup(true)}
                    onFilterChanged={filterChanged}
                    searchFieldChanged={searchFieldChanged}
                    filters={filters}
                />
                <div className="app-content">
                    <AppsList filters={filters} searchField={searchField} />
                </div>
                {showCreateAppPopup && (
                    <ProgressWrapper>
                        <CreateAppPopup onClose={() => setShowCreateAppPopup(false)} app={null} />
                    </ProgressWrapper>
                )}
            </Layout>
        </SurveyBuilderStore>
    );

    function filterChanged(name, value) {
        setFilters((prev) => {
            const next = { ...prev, [name]: value };
            sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(next));
            return next;
        });
    }

    function searchFieldChanged(e) {
        setSearchField(e.target.value);
    }
}

export default AppsComponent;

function loadFilters() {
    const stored = sessionStorage.getItem(FILTERS_STORAGE_KEY);
    if (!stored) {
        return DEFAULT_FILTERS;
    }
    try {
        return { ...DEFAULT_FILTERS, ...JSON.parse(stored) };
    } catch {
        return DEFAULT_FILTERS;
    }
}
